import _ from "lodash";
export const FETCH_LOGGED_IN_USERS = "[ADMIN] FETCH_LOGGED_IN_USERS";
export const FETCH_LOGGED_IN_USERS_START = "[ADMIN] FETCH_LOGGED_IN_USERS_START";
export const FETCH_LOGGED_IN_USERS_SUCCESS = "[ADMIN] FETCH_LOGGED_IN_USERS_SUCCESS";
export const FETCH_LOGGED_IN_USERS_ERROR = "[ADMIN] FETCH_LOGGED_IN_USERS_ERROR";

export const fetchLoggedInUsers = () => {
    return {
        type: FETCH_LOGGED_IN_USERS,
    };
};

export const sortLoggedInUsers = (users) => {
    let sortedUsers = _.orderBy(
        users,
        function (object) {
            return object.loginDate ? new Date(object.loginDate) : null;
        },
        ['desc'],
    );
    return sortedUsers;
};